export default __webpack_public_path__ + "static/media/handofmitra.67661c87.png";